import ChemiNovaEntityType from "./enums/ChemiNovaEntityType";

class EntityStats {
  constructor(
    public entity_type: ChemiNovaEntityType,
    public entity_no: number
  ) {}

  public static getStats(
    stats: EntityStats[] | undefined,
    entity_type: ChemiNovaEntityType
  ) {
    if (stats) {
      for (let i = 0; i < stats.length; i++) {
        if (stats[i].entity_type == entity_type) {
          return stats[i].entity_no;
        }
      }
    }
    return 0;
  }
}

export default EntityStats;
